import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isOnlineOrderCancelledFailed = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.cancelRequest.hasFailed);
